<div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
  <ul class="info-header">
    <li>
      <span class="text-bold">{{ 'feed-advice-report.feedadvicename' | translate }}:</span>
      <span class="wide-label">{{ feedAdvice()?.name }}</span>
    </li>
    @if (customer$ | async; as customer) {
      <li>
        <span class="text-bold">{{ 'feed-advice-report.farmcompany' | translate }}:</span>
        <span class="wide-label">
          {{ customer?.name }}, {{ customer?.street }} {{ customer?.houseNumber }}
          {{ customer?.houseNumberAddition }},
          {{ customer?.city }}
        </span>
      </li>
      <li>
        <span class="text-bold">{{ 'feed-advice-report.customernr' | translate }}:</span>
        <span>{{ customer?.externalId }}</span>
      </li>
    }
    @if (location$ | async; as location) {
      <li>
        <span class="text-bold">{{ 'feed-advice-report.location' | translate }}:</span>
        <span class="wide-label">
          {{ location?.name }}, {{ location?.street }} {{ location?.houseNumber }}
          {{ location?.houseNumberAddition }},
          {{ location?.city }}
        </span>
      </li>
    }
    <li>
      <span class="text-bold">{{ 'feed-advice-report.contactperson' | translate }}:</span>
      <span>{{ feedAdvice()?.advisorName }}</span>
    </li>
    @if (!isWeanedPigletAdvice()) {
      <li>
        <span class="text-bold">{{ 'gender.label' | translate }}</span>
        <span>{{ genders() }}</span>
        <span class="text-bold">{{ 'feedintake.label' | translate }}</span>
        <span>{{ 'feedintake.' + feedAdvice()?.feedIntake?.toLowerCase() | translate }}</span>
        <span class="text-bold">{{ 'feedAdviceType.label' | translate }}</span>
        <span>{{ 'feedAdviceType.' + feedAdvice()?.type.toLowerCase() | translate }}</span>
      </li>
    } @else {
      <li>
        <span class="text-bold">{{ 'feedAdviceType.label' | translate }}</span>
        <span>{{ 'feedAdviceType.' + feedAdvice()?.type.toLowerCase() | translate }}</span>
      </li>
      <li>
        <span class="text-bold">{{ 'feed-advice-detail.weaning-weight' | translate }}</span>
        <span>{{ feedAdvice()?.weaningWeight }}</span>
        <span class="text-bold">{{ 'feed-advice-detail.weaning-age' | translate }}</span>
        <span>{{ feedAdvice()?.weaningAge }}</span>
      </li>
    }
    <li>
      <span class="text-bold">{{
        'feed-advice-properties.phaseTransition.label' | translate
      }}</span>
      <span>
        {{
          'feed-advice-properties.phaseTransition.' + feedAdvice()?.phaseTransition.toLowerCase()
            | translate
        }}
      </span>
      <span class="text-bold">{{ 'feed-advice-report.numberOfPhases' | translate }}:</span>
      <span>{{ feedAdvice()?.numberOfPhases }}</span>
      @if (isRearingGiltAdvice()) {
        <span class="text-bold"
          >{{ 'feed-advice-properties.feeding-type.label' | translate }}:</span
        >
        <span>
          {{
            'feed-advice-properties.feeding-type.' + (feedAdvice()?.feedingType ?? FeedingType.CDI)
              | lowercase
              | translate
          }}
        </span>
      } @else {
        <span class="text-bold">{{ 'feed-advice-report.terminal-boar' | translate }}:</span>
        @if (feedAdvice()?.terminalBoar; as terminalBoar) {
          <span>{{ terminalBoar }}</span>
        } @else {
          <span>{{ 'feed-advice-report.terminal-boar-empty' | translate }}</span>
        }
      }
    </li>
    @if (isRearingGiltAdvice()) {
      <li>
        <span class="text-bold">{{ 'feed-advice-properties.rearingAge.label' | translate }}</span>
        <span class="wide-label">{{ feedAdvice()?.rearingAge }}</span>
      </li>
    }
    <li>
      <span class="text-bold">{{ 'feed-advice-report.remarks' | translate }}:</span>
      <span class="wide-label">{{ feedAdvice()?.description }}</span>
    </li>
  </ul>
</div>
<div class="wrapper--spacing-horizontal">
  <table>
    <thead>
      <tr>
        @if (!isWeanedPigletAdvice() && !isRearingGiltAdvice()) {
          <th>{{ 'feed-advice-report.table.week' | translate }}</th>
        }
        @if (!isRearingGiltAdvice()) {
          <th>{{ 'feed-advice-report.table.day' | translate }}</th>
        }
        @if (isRearingGiltAdvice()) {
          <th>{{ 'scheme-table.weekAge' | translate }}</th>
        }
        @if (isWeanedPigletAdvice()) {
          <th>{{ 'feed-advice-report.table.age' | translate }}</th>
        }
        @if (isRearingGiltAdvice()) {
          <th>{{ 'scheme-table.ageRearing' | translate }}</th>
        }

        <th>{{ 'feed-advice-report.table.weight' | translate }}</th>
        @if (!isWeanedPigletAdvice()) {
          <th>{{ 'feed-advice-report.table.energyvalue' | translate }}</th>
        }
        @for (phase of feedAdvice()?.phases; track phase.phaseNumber) {
          <th>{{ 'feed-advice-report.table.phase' | translate }} {{ phase.phaseNumber }}</th>
        }
        @if (isRearingGiltAdvice() && feedAdvice()?.showDosatorColumns) {
          <th class="align-center">{{ 'scheme-table.dosator_feeding_times' | translate }}</th>
        }
        @for (phase of feedAdvice()?.phases; track phase.phaseNumber; let i = $index) {
          @if (isRearingGiltAdvice() && feedAdvice()?.showDosatorColumns) {
            <th class="align-center">Dosator {{ 'scheme-table.phase' + (i + 1) | translate }}</th>
          }
        }

        <th>{{ 'feed-advice-report.table.feedperday' | translate }}</th>
        <th>{{ 'feed-advice-report.table.cumulative' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="2"></td>
        <td class="align-center">{{ 'scheme-table.feed_unit_kg' | translate }}</td>
        @if (!isWeanedPigletAdvice()) {
          <td class="align-center">
            {{ 'settings.energy.short.' + (energySetting$ | async) | translate }}
          </td>
        }
        @for (phase of feedAdvice()?.phases; track phase.phaseNumber) {
          <td class="align-center">{{ phase.product.productCode }} {{ phase.product.name }}</td>
        }
        @if (isRearingGiltAdvice() && feedAdvice()?.showDosatorColumns) {
          <td [attr.colspan]="(feedAdvice()?.phases?.length ?? 0) + 1"></td>
        }
        <td class="align-center">
          {{ 'scheme-table.feed_unit_' + (isWeanedPigletAdvice() ? 'gr' : 'kg') | translate }}
        </td>
        <td class="align-center">{{ 'scheme-table.feed_unit_kg' | translate }}</td>
      </tr>
      @for (row of schemeTableRows(); track $index) {
        <tr>
          @if (isWeanedPigletAdvice()) {
            <td class="align-right">{{ row.day }}</td>
            <td class="align-right">{{ row.age }}</td>
          }
          @if (isRearingGiltAdvice()) {
            <td class="align-right">{{ row.weekAge }}</td>
            <td class="align-right">{{ row.age }}</td>
          }
          @if (!isWeanedPigletAdvice() && !isRearingGiltAdvice()) {
            <td class="align-right">{{ row.week }}</td>
            <td class="align-right">{{ row.week * 7 - 6 }}</td>
          }
          <td class="align-right">{{ row.weight | agrNumber: '1.1-1' }}</td>
          @if (!isWeanedPigletAdvice()) {
            <td class="align-right">{{ row.energyValuePerDay | agrNumber: '1.2-2' }}</td>
          }
          @for (consumption of row.consumptions; track consumption.phaseNumber) {
            <td class="align-right">{{ consumption.productIntakeInPercentage }}%</td>
          }
          @if (isRearingGiltAdvice() && feedAdvice()?.showDosatorColumns) {
            <td class="align-right">{{ row.feedingTimesPerDay }}</td>
          }
          @for (consumption of row.consumptions; track consumption.phaseNumber) {
            @if (isRearingGiltAdvice() && feedAdvice()?.showDosatorColumns) {
              <td class="align-right">
                {{ consumption.dosatorPosition | agrNumber: '1.1-1' }}
              </td>
            }
          }
          <td class="align-right">
            {{
              isWeanedPigletAdvice()
                ? (row.foodPerDay | agrNumber: '1.0-0')
                : (row.foodPerDay | agrNumber: '1.2-2')
            }}
          </td>
          <td class="align-right">{{ row.cumulative | agrNumber: '1.1-1' }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
@if (isFatteningAdvice()) {
  <div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
    <ul class="info-header">
      <li>
        <span class="text-bold">{{ 'scheme-table.final_weight' | translate }}:</span>
        <span class="finalweight">{{ feedAdvice()?.finalWeight }}</span>
      </li>
    </ul>
  </div>
}
<div class="wrapper--spacing-horizontal spacing-top">
  <table>
    <thead>
      <tr>
        <th>{{ 'feed-advice-report.table.code' | translate }}</th>
        <th class="align-left">{{ 'feed-advice-report.table.name' | translate }}</th>
        @if (hasNettoPrices()) {
          <th class="align-left">
            {{ 'feed-advice-report.table.nettoPricePer100Kg' | translate }}
          </th>
        }
        <th class="align-right">
          {{ 'feed-advice-report.table.energy' | translate }} ({{
            'settings.energy.short.' + (energySetting$ | async) | translate
          }})
        </th>
        <th class="align-right">{{ 'feed-advice-report.table.totalkg' | translate }}</th>
        @if (hasNettoPrices()) {
          <th class="align-right">
            {{ 'feed-advice-report.table.totalNettoPrice' | translate }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (productTotal of productTotals(); track productTotal.productCode) {
        <tr>
          <td>{{ productTotal.productCode }}</td>
          <td class="medium-column">{{ productTotal.productName }}</td>
          @if (hasNettoPrices()) {
            <td class="align-right">
              {{ this.currency }}
              {{ productTotal.nettoPricePer100Kg | agrNumber: '1.2-2' }}
            </td>
          }
          <td class="align-right">{{ productTotal.ewKg | agrNumber: '1.2-2' }}</td>
          <td class="align-right">{{ productTotal.totalKg | agrNumber: '1.1-1' }}</td>
          @if (hasNettoPrices()) {
            <td class="medium-column align-right">
              {{ this.currency }}
              {{ productTotal.totalNettoPrice | agrNumber }}
            </td>
          }
        </tr>
      }
      @if (hasNettoPrices()) {
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="medium-column align-right float-right">
            {{ 'feed-advice-report.table.grandTotalNettoPrice' | translate }}
            {{ this.currency }}
            {{ grandTotalNettoPrice() | agrNumber }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
